module.exports = __webpack_public_path__ + "static/ZEZWOLENIE-d4328db55301ebffa33db5152bbdff5c.pdf";